/*** IMPORTS FROM imports-loader ***/
var define = false;

"use struct";

(function ($, TweenMax, ScrollMagic) {

  require("../../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js");

  var controller = new ScrollMagic.Controller();

  $(document).ready(function () {

    if ($('.section-car').length > 0) {

      var height_container = $('.matrici-tamponi').outerHeight(true);
      effectParallax('.home', '.section-car__bulloni__sx1', '-200%', 1, $('body').outerHeight(true, true));

      effectParallax('.home', '.section-car__bulloni__sx2', '800%', 1, $('body').outerHeight(true, true));
      effectParallax('.home', '.section-car__bulloni__dx1', '300%', 1, $('body').outerHeight(true, true));

      effectParallax('.home', '.section-car__bulloni__sx3', '-300%', 1, $('body').outerHeight(true, true));
      effectParallax('.home', '.section-car__bulloni__dx3', '-300%', 1, $('body').outerHeight(true, true));

      effectParallax('.home', '.section-car__bulloni__dx2', '-400%', 1, $('body').outerHeight(true, true));
    }

  });


  /* Parallax Effect */

  effectParallax = function (container, ele, percent, zindex, heightDuration) {

    var tween = TweenMax
      .to(ele, 0.5, {
        //repeat: 15,
        y: percent,
        ease: Linear.easeNone,
        yoyo: true,
        force3D: true,
        zIndex: zindex,
        transformStyle: "preserve-3d",
        transformPerspective: 600

      });


    var scene = new ScrollMagic.Scene({
      triggerElement: container,
      duration: heightDuration
    }).setTween(tween)
      .addTo(controller)
      .triggerHook(0.8);
    // .addIndicators();
  }

  function resetController() {
    return controller.enabled(false);
  }

})(jQuery, Gsap, ScrollMagic);






//////////////////
// WEBPACK FOOTER
// ../src/js/components/parallax.js
// module id = 0
// module chunks = 0